/* eslint-disable complexity */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import { faStar } from '@fortawesome/free-regular-svg-icons';
import {
  faSubway,
  faLock,
  faInfoCircle,
  faUtensils,
  faConciergeBell,
  faWineGlassAlt,
  faWifi,
  faParking,
  faSwimmingPool,
  faShuttleVan,
  faGamepad,
  faGolfBall,
  faTheaterMasks,
  faTableTennis,
  faBroom,
  faBed,
  faSpa,
  faPaw,
  faBriefcase,
  faSmokingBan,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AmenitiesPopularIcon from './AmenitiesPopularIcon';

const ADDS_ICON_MAPPING = {
  // Most popular
  freeWifi: 'Free WIFI',
  parking: 'Parking',
  familyRooms: 'Family Rooms',
  nonSmoking: 'Non Smoking Rooms',
  pool: 'Indoor Swimming Pool',
  bar: 'Bar',
  shuttle: 'Airport Shuttle',

  // groups
  mostPopular: 'Most Popular',
  foodAndDrink: 'Food and Drink',
  wellness: 'Wellness',
  general: 'General',
  transport: 'Transport',
  entertainment: 'Entertainment and family services',
  cleaning: 'Cleaning services',
  reception: 'Reception Services',
  safety: 'Safety and security',
  activities: 'Activities',
  outdoor: 'Outdoor',
  services: 'Services and Extras',
  pets: 'Pets',
  businessFacilities: 'Business Facilities',
};

export const getIconMap = (item) => {
  const mappedKey = Object.keys(ADDS_ICON_MAPPING).find(
    (key) => ADDS_ICON_MAPPING[key] === item,
  );

  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (mappedKey) {
    // Most popular
    case 'freeWifi':
      return <FontAwesomeIcon icon={faWifi} />;
    case 'parking':
      return <FontAwesomeIcon icon={faParking} />;
    case 'familyRooms':
      return <FontAwesomeIcon icon={faBed} />;
    case 'nonSmoking':
      return <FontAwesomeIcon icon={faSmokingBan} />;
    case 'pool':
      return <FontAwesomeIcon icon={faSwimmingPool} />;
    case 'bar':
      return <FontAwesomeIcon icon={faWineGlassAlt} />;
    case 'shuttle':
      return <FontAwesomeIcon icon={faShuttleVan} />;

    // GROUPS
    case 'mostPopular':
      return <AmenitiesPopularIcon />;

    case 'foodAndDrink':
      return <FontAwesomeIcon icon={faUtensils} />;

    case 'wellness':
      return <FontAwesomeIcon icon={faSpa} />;

    case 'general':
      return <FontAwesomeIcon icon={faInfoCircle} />;

    case 'transport':
      return <FontAwesomeIcon icon={faSubway} />;

    case 'entertainment':
      return <FontAwesomeIcon icon={faGamepad} />;

    case 'cleaning':
      return <FontAwesomeIcon icon={faBroom} />;

    case 'reception':
      return <FontAwesomeIcon icon={faConciergeBell} />;

    case 'safety':
      return <FontAwesomeIcon icon={faLock} />;

    case 'activities':
      return <FontAwesomeIcon icon={faGolfBall} />;

    case 'outdoor':
      return <FontAwesomeIcon icon={faTableTennis} />;

    case 'services':
      return <FontAwesomeIcon icon={faTheaterMasks} />;

    case 'pets':
      return <FontAwesomeIcon icon={faPaw} />;

    case 'businessFacilities':
      return <FontAwesomeIcon icon={faBriefcase} />;

    default:
      return <FontAwesomeIcon icon={faStar} />;
  }
};
